import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { BaseLayoutComponent } from '../base-layout/base-layout.component';
import { AuthService } from '@t-llevo/auth';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-admin-layout',
  standalone: true,
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    NgOptimizedImage,
    RouterLink,
    RouterLinkActive,
    BaseLayoutComponent,
    HeaderComponent,
    MatButtonModule,
    MatIconModule,
    RouterOutlet,
    FooterComponent,
    SidenavComponent,
  ],
})
export class AdminLayoutComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  canShow = false;
  footerTheme: { [style: string]: string } = {
    height: '40px',
  };
  containerTheme: { [style: string]: string } = {
    'min-height': 'calc(100vh - 104px)',
    background: '#f3f4f3',
    position: 'relative',
    margin: '0',
    'border-radius': '0',
    padding: '20px 20px 0 20px',
    'scroll-behavior': 'smooth',
  };

  constructor(private authSrv: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.authSrv.sessionData$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isAuth) => {
        if (!isAuth) {
          this.router.navigate(['/seguridad/iniciar']);
        }
      });
  }
}
